module.exports = __webpack_public_path__ + "static/media/logout.6f30d8c5.svg";